import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";

export const useEnableNewFeatures = (options = {}) => {
  return useMutation((id) => {
    return http.post(HTTP_ENDPOINTS.betaProgram.enableNewFeatures(id));
  }, options);
};
